///all in one
import axios from "@/axios";
export const members = [];

export const memberGetters = {
  getMember: state => {
    return state.members?state.members:[];
  },
  getMemberById: (state) => (id) => {
    return state.members.find(v => v.id == id);
  }
};

export const memberMutations = {
  changeMember(state, value) {
    state.members = value;
  }
};

export const meberActions = {
  act_loadMemeber: async ({ commit,getters }) => {
    const respone = await axios.get("get-members",{
        headers: {
            Authorization: "Bearer " + getters.getAuthToken
        }
    });
    commit("changeMember", respone.data.data);
    return respone;
  }
};
